export const KEY_POINT_RADIUS = 5;